import type { infrastructurePortalUtil } from 'generated-ts-common';
import { intl } from '../../../../lib';

type GenCode = infrastructurePortalUtil.saf.infrastructure.model.svs.GenCode;
export const otherValueIndicator = 'OTHER___';

export type GenCodeValueTypes =
  | string
  | string[]
  | GenCode
  | GenCode[]
  | null
  | undefined;

export function isGenCodeArray(value: GenCodeValueTypes): value is GenCode[] {
  if (
    !value ||
    typeof value === 'string' ||
    !Array.isArray(value) ||
    isStringArray(value)
  ) {
    return false;
  }

  return (value as GenCode[]).every(isGenCode);
}

export function isGenCode(value: GenCodeValueTypes): value is GenCode {
  if (!value || typeof value === 'string' || Array.isArray(value)) {
    return false;
  }
  return 'valueMappedAsHL7' in value;
}

export function isStringArray(value: unknown[] | unknown): value is string[] {
  return Array.isArray(value) && value.every(item => typeof item === 'string');
}

export function createOtherOption(): GenCode {
  return {
    value: 'OTHER',
    codingScheme: 'OTHER',
    displayName: intl('common.other'),
    valueMappedAsHL7: otherValueIndicator
  };
}

export function hasOtherOption(items: GenCode[]): boolean {
  return items.some(isOtherOptionGenCode);
}

export function getOtherOptionText(items: GenCode[]): string {
  const otherOption = items.find(isOtherOptionGenCode);
  if (!otherOption) {
    return '';
  }

  return otherOption.valueMappedAsHL7.substring(otherValueIndicator.length);
}

export function updateOtherOptionValue(
  items: GenCode[],
  newValue: string
): GenCode[] {
  const otherOption = items.find(isOtherOptionGenCode);

  if (!otherOption) {
    const newOption = createOtherOption();
    newOption.valueMappedAsHL7 = otherValueIndicator + newValue;
    return [...items, newOption];
  }

  return items.map(item => {
    if (isOtherOptionValue(item.valueMappedAsHL7)) {
      return {
        ...item,
        valueMappedAsHL7: otherValueIndicator + newValue
      };
    }
    return item;
  });
}

function isOtherOptionGenCode(value: GenCode): boolean {
  return isOtherOptionValue(value.valueMappedAsHL7);
}

function isOtherOptionValue(value: string): boolean {
  return value.startsWith(otherValueIndicator);
}
